export default "__VITE_ASSET__6376c960__"